import { __require as requireFunctionBind } from '../function-bind/index.js';
import { __require as requireFunctionApply } from './functionApply.js';
import { __require as requireActualApply } from './actualApply.js';

var applyBind;
var hasRequiredApplyBind;

function requireApplyBind () {
	if (hasRequiredApplyBind) return applyBind;
	hasRequiredApplyBind = 1;

	var bind = requireFunctionBind();
	var $apply = requireFunctionApply();
	var actualApply = requireActualApply();

	/** @type {import('./applyBind')} */
	applyBind = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};
	return applyBind;
}

export { requireApplyBind as __require };
